// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext, useEffect, useState} from 'react';
import styles from './form.module.less';
import cn from 'classnames';
import {Footer} from './footer';
import {t_states} from './types';
import {Input} from '../../lib/input';
import Eye_show from '../../img/hola2023/icons/16/eye_show.svg';
import Eye_hide from '../../img/hola2023/icons/16/eye_hide.svg';
import Chevron_left from '../../img/hola2023/icons/16/chevron_left.svg';
import {Button} from '../../../../shared/button';
import {is_valid_email} from 'zurl';
import {get_error_description} from './errors';
import {login_process} from './utils';
import {Pass_meter_2023} from '../../ui/pass_meter';
import {Captcha} from '../../login/captcha';
import hopt from 'hola_opt';
import {Checkbox} from '../../lib/checkbox';
import {Lottie} from '../../lib/lottie';
import {img_url} from '../img_url';
import {Settings_context} from '../../settings_ctx';

interface i_login_buttons_props {
    go_to: (type:t_states, direction?: number)=>void;
    get_enc_url: ()=>string;
    signup_subscription: boolean;
    signup_bonus: boolean;
    qr_code: string;
    no_banner?: boolean;
    Banner?: JSX.Element;
    can_back: boolean;
    pro_signup?: boolean;
    img_set?: string;
}

export const State_signup_with_email = (props: i_login_buttons_props)=>{
    const [email, set_email] = useState('');
    const {theme} = useContext(Settings_context);
    const [password, set_password] = useState('');
    const [save_two_step, set_save_two_step] = useState(true);
    const [type_password, set_type_password] = useState('password');
    const [process_state, set_process_state] = useState(login_process.state);
    const [error, set_error] = useState({
        fields: [],
        code: '',
    });
    useEffect(()=>{
        if (!password && login_process.last_process_error == 'wrong_password')
            return;
        set_error({fields: [], code: ''});
    }, [email, password]);
    useEffect(()=>{
        login_process.init_recaptcha();
        const uns_error_change = login_process.on('last_process_error_changed',
        ()=>{
            if (login_process.last_process_error == 'wrong_password')
                set_password('');
            if (login_process.last_process_error == 'recaptcha')
            {
                set_error({
                    fields: ['captcha'],
                    code: login_process.last_process_error,
                });
                return;
            }
            set_error({
                fields: login_process.last_process_error ?
                    ['email', 'password'] : [],
                code: login_process.last_process_error,
            });
        });
        const uns_state = login_process.on('state_changed', ()=>{
            set_process_state(login_process.state);
        });
        return ()=>{
            uns_error_change();
            uns_state();
        };
    }, []);
    return <div className={styles.login_buttons}>
        <div className={cn(styles.lottie_overlay,
          process_state=='in_progress' && styles.lottie_visible)}>
          <Lottie src={img_url('animation/loading.json')} width={'375px'}
            height={'375px'} autoplay loop/>
        </div>
        <div className={styles.head}>
          {props.can_back && <button className={styles.back_btn} onClick={()=>{
            props.go_to('signup_buttons', -1);
          }}><Chevron_left/></button>}
          <p className={styles.login_signup_text}><b>Sign up</b></p>
        </div>
        <form className={styles.login_form}>
          <Input label={'Email'} placeholder={'user@example.com'}
            on_change={set_email} value={email}
            error_style={error.fields.includes('email')}
            on_blur={()=>{
              if (!is_valid_email(email))
              {
                return set_error({fields: ['email'], code:
                  'invalid_email'});
              }
            }}
            cl={styles.email_field}
          />
          <Input label={'Password'} placeholder={''} type={type_password}
            on_change={set_password} value={password}
            error_style={error.fields.includes('password')}
            Icon={p=>{
              return <div className={p.className}
                onClick={()=>set_type_password(type_password=='password'
                  ? 'text' : 'password')}>
                  {type_password=='password' ? <Eye_hide /> : <Eye_show/>}
                </div>;
            }}
            no_margin
            error={error.code && !error.fields.includes('captcha') ?
              get_error_description(error.code, email, props.go_to,
                props.get_enc_url, true, false) : ''}/>
          <div className={cn(cn(styles.pass_meter, error.code &&
            styles.hidden_pass_meter))}>
            <Pass_meter_2023 pass={password} email={email}/>
          </div>
          {hopt.mtcaptcha && hopt.mtcaptcha.enable && <Captcha
            error_style={error.fields.includes('captcha')}
            on_verified={()=>{
              set_error({fields: [], code: ''});
            }} error={error}/>}
          <div className={styles.message_checkbox_save_two}>
            <Checkbox caption={''} checked={save_two_step}
              on_change={set_save_two_step} size={'sm'}
              cls={styles.checkbox}/>
            <p className={cn(theme.p5)}>Trust this device</p>
          </div>
          <Button color={'black'} no_jump
            caption={'Create a free account'} on_click={()=>{
              if (!is_valid_email(email))
              {
                set_error({fields: ['email'], code: 'invalid_email'});
                return;
              }
              if (!password)
              {
                set_error({fields: ['password'], code: 'empty_password'});
                return;
              }
              if (password.length < 8)
              {
                set_error({fields: ['password'], code: 'short_password'});
                return;
              }
              login_process.create_new_account(email, password, save_two_step,
                props.signup_subscription, props.signup_bonus,
                props.qr_code, props.pro_signup, props.go_to,
                props.get_enc_url);
            }}
            disabled={!!error.code || process_state=='in_progress'}
            cls={cn(styles.signup_button,
              process_state=='in_progress' && styles.hidden_cta)}/>
        </form>
        <p className={cn(theme.p3, styles.login_signup_switch)}>
          Already have an account? <a className={styles.underline}
            onClick={e=>{
              e.preventDefault();
              props.go_to(props.can_back ? 'login_buttons'
                : 'login_with_email');
            }}
          href='#'>Log in</a></p>
        <Footer label={'Sign up'} google_terms img_set={props.img_set}/>
      </div>;
};
